export default __webpack_public_path__ + "static/media/ele_example_1_1.dfec2b1e.png";